import React from 'react'
import { Outlet } from 'react-router-dom'

const PartnerManagement = () => {
  return (
       <Outlet />
  )
}

export default PartnerManagement
